export const build = { date:"2026-06-21.1359", stage:"alpha" }
